import { RightOutlined } from '@ant-design/icons'
import { Avatar, Button, Card, Flex } from 'antd'
import React from 'react'
import { UIChatThread } from '../../types'

type Props = {
  thread: UIChatThread
  onOpenThread: () => void
}

export const ThreadBar: React.FC<Props> = ({ thread, onOpenThread }) => {
  const pictureUrl = thread.pictureUrl
  const countMessages = thread.countMessages

  return (
    <>
      <Flex className="p-2">
        <Card
          size="small"
          styles={{ body: { padding: '4px' } }}
          onClick={onOpenThread}
        >
          <Avatar size={24} src={pictureUrl} />

          <Button
            type="link"
            size="small"
            icon={<RightOutlined />}
            iconPosition="end"
          >
            {countMessages} {countMessages > 1 ? 'replies' : 'reply'}
          </Button>
        </Card>
      </Flex>
    </>
  )
}
